import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert } from '@mui/material';
import { UserInterface, UserRoleInterface, SubscriptionPlanInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  userToUpdate: UserInterface | null;
  setUserToUpdate: React.Dispatch<React.SetStateAction<UserInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  userRoles: UserRoleInterface[];
  subscriptionPlans: SubscriptionPlanInterface[];
  updateError?: string | null;
  updateSuccess?: string | null;
}

const UserUpdateDialog: React.FC<Props> = ({
  open,
  userToUpdate,
  setUserToUpdate,
  onClose,
  onSave,
  userRoles,
  subscriptionPlans,
  updateError,
  updateSuccess,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update User</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
        <TextField
            label="Username"
            value={userToUpdate?.username ?? ''}
            onChange={e => setUserToUpdate(u => u ? { ...u, username: e.target.value } : u)}
            fullWidth
            margin="dense"
        />
        <TextField
            label="Password"
            type="password"
            value={userToUpdate?.password ?? ''}
            onChange={e => setUserToUpdate(u => u ? { ...u, password: e.target.value } : u)}
            fullWidth
            margin="dense"
        />
        <TextField
            label="Name"
            value={userToUpdate?.name ?? ''}
            onChange={e => setUserToUpdate(u => u ? { ...u, name: e.target.value } : u)}
            fullWidth
            margin="dense"
        />
        <TextField
            label="Description"
            value={userToUpdate?.description ?? ''}
            onChange={e => setUserToUpdate(u => u ? { ...u, description: e.target.value } : u)}
            fullWidth
            margin="dense"
        />
        <TextField
            label="Email"
            value={userToUpdate?.email ?? ''}
            onChange={e => setUserToUpdate(u => u ? { ...u, email: e.target.value } : u)}
            fullWidth
            margin="dense"
        />
        <TextField
            label="Phone"
            value={userToUpdate?.phone ?? ''}
            onChange={e => setUserToUpdate(u => u ? { ...u, phone: e.target.value } : u)}
            fullWidth
            margin="dense"
        />
        <TextField
            label="Address"
            value={userToUpdate?.address ?? ''}
            onChange={e => setUserToUpdate(u => u ? { ...u, address: e.target.value } : u)}
            fullWidth
            margin="dense"
        />

        <FormControl fullWidth margin="dense">
        <InputLabel id="user-role-label">User Role</InputLabel>
        <Select
            labelId="user-role-label"
            value={userToUpdate?.userRoleId ?? ''}
            label="User Role"
            onChange={e => setUserToUpdate(u => u ? { ...u, userRoleId: Number(e.target.value) } : u)}
        >
            {userRoles.map(role => (
            <MenuItem key={role.id} value={role.id}>{role.roleName}</MenuItem>
            ))}
        </Select>
        </FormControl>

        <TextField
        label="Available Tokens"
        type="number"
        value={userToUpdate?.availableTokens ?? ''}
        onChange={e => setUserToUpdate(u => u ? { ...u, availableTokens: Number(e.target.value) } : u)}
        fullWidth
        margin="dense"
        />
        <FormControl fullWidth margin="dense">
        <InputLabel id="active-label">Active</InputLabel>
        <Select
            labelId="active-label"
            value={userToUpdate?.active ? 'yes' : 'no'}
            label="Active"
            onChange={e => setUserToUpdate(u => u ? { ...u, active: e.target.value === 'yes' } : u)}
        >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
        </Select>
        </FormControl>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);

export default UserUpdateDialog;